import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDashboard } from "@tabler/icons-react";
import { DashboardFiltersDef } from "./DashboardFiltersDef";

export const DashboardIcon = IconDashboard;
export const DashboardHelpText = '* Dashboard.';

export class DashboardFilters extends Entity<DashboardFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DashboardFiltersDef(), parentKeys);
        this.Form = import('./DashboardFiltersForm').then((module) => module.DashboardFiltersForm);
        this.Title = "Dashboard";
        this.HelpText = DashboardHelpText;
        this.Icon = DashboardIcon;
    }
}